/**
 * Small client-side rollout gates.
 *
 * This project does not currently have a general feature-flag service. Keep
 * the defaults in one place and permit a page/bootstrap override through
 * `window.__COUNTERTOP_FEATURE_FLAGS__`; components may also pass an override
 * in tests. A missing flag is always off.
 */
export const FEATURE_FLAG_DEFAULTS = Object.freeze({
  vendor_exclusion_review: true,
  next_order_items: false,
});

const hasOwn = (object, key) => Object.prototype.hasOwnProperty.call(object || {}, key);

export function featureEnabled(name, overrides = null) {
  if (hasOwn(overrides, name)) return overrides[name] === true;

  const runtime = typeof globalThis !== 'undefined'
    ? globalThis.__COUNTERTOP_FEATURE_FLAGS__
    : null;
  if (hasOwn(runtime, name)) return runtime[name] === true;

  return FEATURE_FLAG_DEFAULTS[name] === true;
}
